AFRAME.registerComponent('search-mode', {
    schema: {},
    init: function () {
        this.currentStock = null;
        this.themeMode = 'Dark';

        try {
            if (typeof getCacheItem === 'function') {
                const mainSettings = getCacheItem('mainSettings');
                if (mainSettings && mainSettings.themeMode) {
                    this.themeMode = mainSettings.themeMode;
                }
            }
        } catch (e) { console.error(e); }

        this.setThemeChangeListener();

        this.el.addEventListener('enter-search-mode', this.enterSearchMode.bind(this));

        this.el.sceneEl.addEventListener('chart-settings-changed', (e) => {
            if (!e.detail) return;
            let { type, value } = e.detail;
            if (type === 'chartType') type = 'type';

            const centerChart = document.querySelector('#center-stock-chart');
            if (centerChart) {
                centerChart.setAttribute('tradingview-universal-chart', type, value);
            }
        });

        this.setupDataListeners();
    },

    setThemeChangeListener: function () {
        this.el.sceneEl.addEventListener('theme-changed', (event) => {
            if (event.detail && event.detail.themeMode) {
                this.themeMode = event.detail.themeMode;
                this.updateBackgrounds();
            }
        });
    },

    _getSlots: function () {
        return [
            {
                name: 'CENTER',
                targetPos: { x: 0, y: 1.6, z: -1.2 },
                searchPos: { x: 0, y: 2.2, z: -1.2 },
                searchRot: { x: 0, y: 0, z: 0 }
            },
            {
                name: 'LEFT',
                targetPos: { x: -0.8, y: 1.6, z: -2.5 },
                searchPos: { x: -0.8, y: 2.22, z: -2.5 },
                searchRot: { x: 0, y: 45, z: 0 }
            },
            {
                name: 'RIGHT',
                targetPos: { x: 0.8, y: 1.6, z: -2.5 },
                searchPos: { x: 0.8, y: 2.22, z: -2.5 },
                searchRot: { x: 0, y: -45, z: 0 }
            }
        ];
    },

    enterSearchMode: function (stock) {
        this.currentStock = stock;

        const searchContainer = document.querySelector('.search-container');
        if (searchContainer && searchContainer.components['search-handler']) {
            searchContainer.components['search-handler'].clearSearch();
        } else {
            const searchInput = document.querySelector('#ticker-search-input');
            if (searchInput) {
                searchInput.value = 'Search tickers or company...';
                const clearBtn = document.querySelector('#search-clear-button');
                if (clearBtn) clearBtn.setAttribute('visible', 'false');
                searchInput.dispatchEvent(new Event('input'));
                searchInput.blur();
            }
        }

        const searchPanelRef = document.querySelector('#search-center-panel');
        const isAlreadyOpen = searchPanelRef && searchPanelRef.getAttribute('visible');

        const mainPanel = document.querySelector('#large-center-panel');
        const watchlistTable = document.querySelector('#watchlist-table');

        let existingMainPanel = null;
        if (mainPanel && mainPanel.getAttribute('visible')) {
            existingMainPanel = mainPanel;
        } else if (watchlistTable && watchlistTable.getAttribute('visible')) {
            existingMainPanel = watchlistTable;
        }

        this.wasWatchlistOpen = (existingMainPanel && existingMainPanel.id === 'watchlist-table');

        if (!isAlreadyOpen) {
            if (existingMainPanel) {
                this.savedMainPanelRotation = existingMainPanel.getAttribute('rotation');
                this.savedMainPanelExpectedRotation = existingMainPanel.getAttribute('expected-panel-rotation');
            }
        }

        const switchEl = document.querySelector('[switch-table-chart]');
        if (switchEl && switchEl.components['switch-table-chart']) {
            const stc = switchEl.components['switch-table-chart'];
            const isVisibleAttr = switchEl.getAttribute('visible');
            
            const chartCtrlEl = document.querySelector('[chart-type-control]');
            let isWatchlist = false;
            if (chartCtrlEl) {
                const attr = chartCtrlEl.getAttribute('chart-type-control');
                if (attr && attr.selectedPrimeAction === 'watchlist-reports') {
                    isWatchlist = true;
                }
            }
            
            this.wasSwitchTableChartVisible = isWatchlist && (isVisibleAttr === true || isVisibleAttr === 'true');
            this.savedSwitchTableView = stc.currentView;
            stc.hide();
        } else {
            this.wasSwitchTableChartVisible = false;
            this.savedSwitchTableView = 'chart';
        }

        this.newsGraphWasActive = document.body.classList.contains('news-graph-active');
        if (this.newsGraphWasActive) {
            const ngEl = document.querySelector('[news-graph-vr]');
            const viz = ngEl ? ngEl.components['news-graph-vr'] : null;
            this.newsGraphHadSelection = !!(viz && viz.selectedNodeEl);
        } else {
            this.newsGraphHadSelection = false;
        }

        this.hideOtherPanels();

        if (typeof setCacheItem === 'function') {
            try { setCacheItem('last-opened-stock', stock, 60); } catch (e) { }
        }

        this.renderSearchPanel();

        if (!isAlreadyOpen) {
            const tolerance = 0.5;
            const slots = this._getSlots();

            const searchPanel = document.querySelector('#search-center-panel');

            if (existingMainPanel && searchPanel) {
                const mainPos = existingMainPanel.getAttribute('position');
                const mainRot = existingMainPanel.getAttribute('rotation');


                if (mainPos) {
                    let matchedSlot = null;

                    for (const slot of slots) {
                        const dx = mainPos.x - slot.targetPos.x;
                        const dz = mainPos.z - slot.targetPos.z;
                        const distXZ = Math.sqrt(dx * dx + dz * dz);

                        if (distXZ < tolerance) {
                            matchedSlot = slot;
                            break;
                        }
                    }

                    if (matchedSlot) {
                        searchPanel.setAttribute('position', matchedSlot.searchPos);
                        searchPanel.setAttribute('rotation', matchedSlot.searchRot);
                        searchPanel.setAttribute('expected-panel-rotation', AFRAME.utils.coordinates.stringify(matchedSlot.searchRot));

                        searchPanel.classList.remove('billboard-y');
                    } else {
                        const newPos = { x: mainPos.x, y: 2.2, z: mainPos.z };
                        searchPanel.setAttribute('position', newPos);

                        let autoRotate = true;
                        try {
                            const ms = document.querySelector('[main-settings]');
                            if (ms && ms.components['main-settings']) {
                                autoRotate = ms.components['main-settings'].data.autoRotatePanels;
                            }
                        } catch (e) { }

                        if (autoRotate) {
                            searchPanel.setAttribute('rotation', '0 0 0');
                            searchPanel.classList.add('billboard-y');

                            const cameraRig = document.querySelector('#cameraRig');
                            if (cameraRig) cameraRig.emit('update-billboards-list');

                            searchPanel.setAttribute('expected-panel-rotation', AFRAME.utils.coordinates.stringify(mainRot));

                        } else {
                            searchPanel.classList.remove('billboard-y');
                            searchPanel.setAttribute('rotation', mainRot);
                            searchPanel.setAttribute('expected-panel-rotation', AFRAME.utils.coordinates.stringify(mainRot));
                        }
                    }
                }
            }
        }

        try {
            const msEl = document.querySelector('[main-settings]');
            if (msEl && msEl.components['main-settings']) {
                const ms = msEl.components['main-settings'];
                if (ms.isRepositioning) {
                    const handle = searchPanel.querySelector('#move-search-panel-area');
                    if (handle) {
                        handle.setAttribute('visible', 'true');
                        handle.setAttribute('data-raycastable', 'true');
                    }
                }
            }
        } catch (e) { console.warn('Error checking reposition mode on entry', e); }
        
        // update back button 
        const button3DChart = document.querySelector('#top-menu-container .top-level-text-can-be-active')
        if (button3DChart) {
            const activeColor = button3DChart.getAttribute('active-color')
            if (activeColor) button3DChart.setAttribute('color', activeColor);
        }
    },

    exitSearchMode: function () {
        const searchPanel = document.querySelector('#search-center-panel');
        if (searchPanel) {
            searchPanel.setAttribute('visible', 'false');
        }

        const centerPanelContent = document.querySelector('#large-center-panel-content');
        if (centerPanelContent) {
            centerPanelContent.setAttribute('visible', 'true');
            const visualizer = centerPanelContent.querySelector('[stock-cube-visualizer]');
            if (visualizer) visualizer.setAttribute('visible', 'true');
        }

        const largeCenterPanel = document.querySelector('#large-center-panel');
        const watchlistTable = document.querySelector('#watchlist-table');

        if (this.wasWatchlistOpen) {
            if (watchlistTable) watchlistTable.setAttribute('visible', 'true');
            if (largeCenterPanel) largeCenterPanel.setAttribute('visible', 'false');

            this.el.sceneEl.emit('set-news-filter-ui', { filter: 'watchlist' });
            this.el.sceneEl.emit('news-filter-changed', { filter: 'watchlist' });
        } else {
            if (largeCenterPanel) largeCenterPanel.setAttribute('visible', 'true');
            if (watchlistTable) watchlistTable.setAttribute('visible', 'false');
        }

        const newsGraphActive = this.newsGraphWasActive;
        const hasSelection = this.newsGraphHadSelection;

        const rightContainerExit = document.querySelector('#right-container');
        if (rightContainerExit) {
            const exitAllTabs = rightContainerExit.querySelectorAll('.live-chart-tab, .performance-tab, .profile-tab, .financials-tab');
            exitAllTabs.forEach(t => t.setAttribute('visible', 'false'));
            const exitHeader = rightContainerExit.querySelector('.main-header');
            if (exitHeader) exitHeader.setAttribute('visible', newsGraphActive ? 'false' : 'true');

            if (newsGraphActive) {
                const liveChartBtn = rightContainerExit.querySelector('[data-label="Live Chart"]');
                if (liveChartBtn) {
                    liveChartBtn.setAttribute('visible', 'false'); // stays invisible in news graph
                    liveChartBtn.classList.remove('hidden-in-search-mode');
                    liveChartBtn.setAttribute('position', '-0.46 0.84 0.03'); // restore real position
                }
                const settingsBtn = rightContainerExit.querySelector('.right-panel-settings-button');
                if (settingsBtn) {
                    settingsBtn.classList.remove('hidden-in-search-mode');
                }
            }
        }

        if (newsGraphActive) {
            const newsGraphWrapper = document.getElementById('news-graph-wrapper');
            if (newsGraphWrapper) newsGraphWrapper.setAttribute('visible', 'true');

            const legendPanel = document.getElementById('news-graph-legend-vr');
            if (legendPanel) legendPanel.setAttribute('visible', 'true');

            const settingsPanel = document.getElementById('news-graph-settings-panel');
            if (settingsPanel) settingsPanel.setAttribute('visible', 'true');

            const leftPanel2 = document.querySelector('#left-panel-2');

            if (hasSelection) {
                const rightOverview = document.getElementById('news-graph-overview-vr-right');
                if (rightOverview) rightOverview.setAttribute('visible', 'true');

                if (leftPanel2) {
                    const s1 = leftPanel2.querySelector('#news-screen-1');
                    const s2 = leftPanel2.querySelector('#news-screen-2');
                    if (s1) s1.setAttribute('visible', 'false');
                    if (s2) s2.setAttribute('visible', 'false');
                }

                const sourcesPanel = document.querySelector('#news-graph-sources-vr');
                if (sourcesPanel) sourcesPanel.setAttribute('visible', 'true');
            } else {
                const rightOverview = document.getElementById('news-graph-overview-vr-right');
                if (rightOverview) rightOverview.setAttribute('visible', 'true');

                const sourcesPanel = document.querySelector('#news-graph-sources-vr');
                if (sourcesPanel) sourcesPanel.setAttribute('visible', 'false');

                if (leftPanel2) {
                    const s1 = leftPanel2.querySelector('#news-screen-1');
                    if (s1) s1.setAttribute('visible', 'true');
                }
            }

            const zeroPlane = document.querySelector('#zero-plane');
            if (zeroPlane) zeroPlane.setAttribute('visible', 'false');

            const currentTimeDate = document.querySelector('#current-time-date');
            if (currentTimeDate) currentTimeDate.setAttribute('visible', 'true');
        } else {
            const zeroPlane = document.querySelector('#zero-plane');
            if (zeroPlane) zeroPlane.setAttribute('visible', 'true');

            const stockBanner = document.querySelector('#stock-banner');
            if (stockBanner) stockBanner.setAttribute('visible', 'true');

            const currentTimeDate = document.querySelector('#current-time-date');
            if (currentTimeDate) currentTimeDate.setAttribute('visible', 'true');

            const dock = document.querySelector('#dock');
            if (dock) dock.setAttribute('visible', 'true');

            const rightContainer = document.querySelector('#right-container');
            if (rightContainer) {
                const liveChartBtn = rightContainer.querySelector('[data-label="Live Chart"]');
                if (liveChartBtn) {
                    liveChartBtn.setAttribute('visible', 'true');
                    liveChartBtn.classList.remove('hidden-in-search-mode');
                    liveChartBtn.setAttribute('position', '-0.46 0.84 0.03');
                    setTimeout(() => liveChartBtn.dispatchEvent(new Event('click')), 50);
                }

                const settingsBtn = rightContainer.querySelector('.right-panel-settings-button');
                if (settingsBtn) {
                    settingsBtn.setAttribute('visible', 'true');
                    settingsBtn.classList.remove('hidden-in-search-mode');
                    settingsBtn.setAttribute('position', '0.6 0.62 0.03');
                }

                const allBtns = rightContainer.querySelectorAll('.hidden-in-search-mode');
                allBtns.forEach(btn => {
                    btn.setAttribute('visible', 'true');
                    btn.classList.remove('hidden-in-search-mode');
                });
            }

            const chartTypeControl = document.querySelector('#chart-type-control');
            if (chartTypeControl) {
                if (chartTypeControl.components['chart-type-control']) {
                    chartTypeControl.components['chart-type-control'].show();
                } else {
                    chartTypeControl.setAttribute('visible', 'true');
                }
            }
        }

        if (this.wasSwitchTableChartVisible && !newsGraphActive) {
            const switchEl = document.querySelector('[switch-table-chart]');
            if (switchEl && switchEl.components['switch-table-chart']) {
                const stc = switchEl.components['switch-table-chart'];
                stc.el.setAttribute('visible', true);
                stc.currentView = 'chart';
                if (largeCenterPanel) largeCenterPanel.setAttribute('visible', true);
                if (watchlistTable) watchlistTable.setAttribute('visible', false);
                stc.render();
                stc.updateButtonStyles();
                stc.el.sceneEl.emit('watchlist-show-chart');
            }
        }

        const mainSettings = document.querySelector('[main-settings]');
        const searchPanelRef = document.querySelector('#search-center-panel');

        if (searchPanelRef) {
            const sPos = searchPanelRef.getAttribute('position');
            const sRot = searchPanelRef.getAttribute('rotation');

            if (sPos) {
                const tolerance = 0.5;
                const slots = this._getSlots();

                let matchedSlot = null;
                for (const slot of slots) {
                    const dx = sPos.x - slot.searchPos.x;
                    const dy = sPos.y - slot.searchPos.y;
                    const dz = sPos.z - slot.searchPos.z;
                    const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);
                    if (dist < tolerance) {
                        matchedSlot = slot;
                        break;
                    }
                }

                if (matchedSlot) {
                    const panelsToSync = [
                        document.getElementById('large-center-panel'),
                        document.getElementById('watchlist-table')
                    ].filter(p => p !== null);

                    panelsToSync.forEach(panel => {
                        let targetY = matchedSlot.targetPos.y;
                        if (panel.id === 'watchlist-table') {
                            const isCenterSlot = Math.abs(matchedSlot.targetPos.x) < 0.4;
                            targetY = isCenterSlot ? 2.57 : 2.65;
                        }

                        panel.setAttribute('position', { x: matchedSlot.targetPos.x, y: targetY, z: matchedSlot.targetPos.z });

                        let targetRot = matchedSlot.searchRot;
                        if (matchedSlot.name === 'CENTER' && panel.id === 'large-center-panel') {
                            targetRot = { x: 0, y: -45, z: 0 };
                        }

                        panel.setAttribute('rotation', targetRot);
                        panel.setAttribute('expected-panel-rotation', AFRAME.utils.coordinates.stringify(targetRot));
                    });

                } else {
                    const targetRestorePanel = this.wasWatchlistOpen ? (watchlistTable || largeCenterPanel) : largeCenterPanel;
                    if (targetRestorePanel) {
                        targetRestorePanel.setAttribute('position', sPos);

                        if (this.savedMainPanelRotation) {
                            targetRestorePanel.setAttribute('rotation', this.savedMainPanelRotation);
                        } else if (sRot) {
                            targetRestorePanel.setAttribute('rotation', sRot);
                        }

                        if (sRot) {
                            targetRestorePanel.setAttribute('expected-panel-rotation', AFRAME.utils.coordinates.stringify(sRot));
                        }
                    }
                }
            }
        }

        if (mainSettings && mainSettings.components['main-settings']) {
            setTimeout(() => {
                mainSettings.components['main-settings']._savePanelPositions();
            }, 100);
        }
        
        // update back button 
        const button3DChart = document.querySelector('#top-menu-container .top-level-text-can-be-active')
        if (button3DChart) button3DChart.setAttribute('color', '#666');

        if (searchPanel) {
            const pos = searchPanel.getAttribute('position') || { x: 0, y: 2.2, z: -1.2 };
            searchPanel.setAttribute('position', { x: pos.x, y: 12.2, z: pos.z });
        }
    },

    _proceedAddToWatchlist: function () {
        if (!this.currentStock) {
            if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                window.WatchlistApp.Popup.showNotificationPopup("No Stock Selected", "Please select a stock first.");
            }
            return;
        }

        const ticker = this.currentStock.ticker;
        const companyName = (this.currentStock.tickerDetails && this.currentStock.tickerDetails.name) || this.currentStock.name || ticker;

        if (ticker && window.WatchlistApp) {
            const Manager = window.WatchlistApp.Manager;
            const State = window.WatchlistApp.State;

            if (Manager && State) {
                const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
                let count = 0;
                if (State.currentWatchlistData) {
                    count = Array.isArray(State.currentWatchlistData) ? State.currentWatchlistData.length : Object.keys(State.currentWatchlistData).length;
                }

                const MAX_ITEMS_FREE = 50;

                if (!isPremium && count >= MAX_ITEMS_FREE) {
                    if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                        window.WatchlistApp.Popup.showPremiumLimitPopup(
                            "Unlimited stocks in watchlist are coming soon!",
                            `Adding more than ${MAX_ITEMS_FREE} assets is a Pro feature currently in development.`
                        );
                    }
                    return;
                }
            }
        }

        if (ticker) {
            if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddToWatchlistPopup) {
                window.WatchlistApp.Popup.showAddToWatchlistPopup(ticker, companyName);
            } else {
                console.warn("WatchlistApp.Popup.showAddToWatchlistPopup not available");
            }
        }
    },

    hideOtherPanels: function () {
        const centerPanelContent = document.querySelector('#large-center-panel-content');
        if (centerPanelContent) {
            const visualizer = centerPanelContent.querySelector('[stock-cube-visualizer]');
            if (visualizer) visualizer.setAttribute('visible', 'false');
            centerPanelContent.setAttribute('visible', 'false');
        }
        const largeCenterPanel = document.querySelector('#large-center-panel');
        if (largeCenterPanel) largeCenterPanel.setAttribute('visible', 'false');

        const zeroPlane = document.querySelector('#zero-plane');
        if (zeroPlane) zeroPlane.setAttribute('visible', 'false');

        const stockBanner = document.querySelector('#stock-banner');
        if (stockBanner) stockBanner.setAttribute('visible', 'false');

        const currentTimeDate = document.querySelector('#current-time-date');
        if (currentTimeDate) currentTimeDate.setAttribute('visible', 'false');

        const dock = document.querySelector('#dock');
        if (dock) dock.setAttribute('visible', 'false');

        const newsGraphNowActive = this.newsGraphWasActive;

        const rightContainer = document.querySelector('#right-container');
        if (rightContainer) {
            if (newsGraphNowActive) {
                const header = rightContainer.querySelector('.main-header');
                if (header) header.setAttribute('visible', 'true');
            }
            const performanceBtn = rightContainer.querySelector('[data-label="Performance"]');
            if (performanceBtn) performanceBtn.dispatchEvent(new Event('click'));

            const liveChartBtn = rightContainer.querySelector('[data-label="Live Chart"]');
            if (liveChartBtn) {
                liveChartBtn.setAttribute('visible', 'false');
                liveChartBtn.classList.add('hidden-in-search-mode');
                liveChartBtn.setAttribute('position', '0 10 0');
            }

            const settingsBtn = rightContainer.querySelector('.right-panel-settings-button');
            if (settingsBtn) {
                settingsBtn.setAttribute('visible', 'false');
                settingsBtn.classList.add('hidden-in-search-mode');
            }
        }

        const chartTypeControl = document.querySelector('#chart-type-control');
        if (chartTypeControl) {
            if (chartTypeControl.components['chart-type-control']) {
                chartTypeControl.components['chart-type-control'].hide();
            } else {
                chartTypeControl.setAttribute('visible', 'false');
            }
        }

        const switchEl = document.querySelector('[switch-table-chart]');
        if (switchEl) switchEl.setAttribute('visible', 'false');

        const tableEl = document.querySelector('[watchlist-table]');
        if (tableEl) tableEl.setAttribute('visible', 'false');

        if (newsGraphNowActive) {
            const newsGraphWrapper = document.getElementById('news-graph-wrapper');
            if (newsGraphWrapper) newsGraphWrapper.setAttribute('visible', 'false');

            const legendPanel = document.getElementById('news-graph-legend-vr');
            if (legendPanel) legendPanel.setAttribute('visible', 'false');

            const settingsPanel = document.getElementById('news-graph-settings-panel');
            if (settingsPanel) settingsPanel.setAttribute('visible', 'false');

            const leftOverview = document.getElementById('news-graph-overview-vr-left');
            if (leftOverview) leftOverview.setAttribute('visible', 'false');

            const rightOverview = document.getElementById('news-graph-overview-vr-right');
            if (rightOverview) rightOverview.setAttribute('visible', 'false');

            const sourcesPanel = document.querySelector('#news-graph-sources-vr');
            if (sourcesPanel) sourcesPanel.setAttribute('visible', 'false');
        }
    },

    getOrCreateSearchPanel: function () {
        const sceneWrapper = document.querySelector('#scene-wrapper');
        let searchPanel = document.querySelector('#search-center-panel');
        if (!searchPanel && sceneWrapper) {
            searchPanel = document.createElement('a-entity');
            searchPanel.id = 'search-center-panel';
            searchPanel.setAttribute('position', '0 2.2 -1.2');
            sceneWrapper.appendChild(searchPanel);
        }

        if (searchPanel) {
            searchPanel.setAttribute('visible', 'true');
            const pos = searchPanel.getAttribute('position') || { x: 0, y: 12.2, z: -1.2 };
            searchPanel.setAttribute('position', { x: pos.x, y: 2.2, z: pos.z });
        }
        return searchPanel;
    },

    renderSearchPanel: function () {
        const parentEl = this.getOrCreateSearchPanel();
        if (!parentEl) return;

        let anchor = parentEl.querySelector('#search-panel-ui-anchor');
        if (!anchor) {
            this.buildInitialStructure(parentEl);
            anchor = parentEl.querySelector('#search-panel-ui-anchor');
        }

        this.updateDataElements(anchor);

        this.updateBackgrounds();

        if (!parentEl.querySelector('.blocking-plane')) {
            const blockingPlane = document.createElement('a-rounded-box');
            blockingPlane.className = 'blocking-plane';
            blockingPlane.setAttribute('width', '1.17');
            blockingPlane.setAttribute('height', '1.93');
            blockingPlane.setAttribute('depth', '0.01');
            blockingPlane.setAttribute('radius', '0.05');
            blockingPlane.setAttribute('color', '#000');
            blockingPlane.setAttribute('opacity', '0.5');
            blockingPlane.setAttribute('visible', 'false');
            blockingPlane.setAttribute('drag-rotate-y', 'target: #search-center-panel');
            blockingPlane.setAttribute('position', '0 0 0.05');

            parentEl.appendChild(blockingPlane);

            try {
                const msEl = document.querySelector('[main-settings]');
                if (msEl && msEl.components['main-settings']) {
                    const ms = msEl.components['main-settings'];
                    ms.switchBlockingElement(parentEl, !ms.isRepositioning);
                }
            } catch (e) { }
        }

    },

    buildInitialStructure: function (parentEl) {
        parentEl.setAttribute('scale', '1.2 0.75 1');

        const bgDark = document.createElement('a-rounded-box');
        bgDark.id = 'center-panel-bg-dark';
        bgDark.setAttribute('width', 1.17);
        bgDark.setAttribute('height', 1.93);
        bgDark.setAttribute('depth', 0.002);
        bgDark.setAttribute('radius', 0.05);
        bgDark.setAttribute('color', '#111');
        bgDark.setAttribute('position', '0 0 0');
        bgDark.setAttribute('opacity', 1);
        bgDark.setAttribute('material', { shader: 'flat', opacity: 1, color: '#111' });
        bgDark.setAttribute('visible', true);
        parentEl.appendChild(bgDark);

        const bgLight = document.createElement('a-rounded-box');
        bgLight.id = 'center-panel-bg-light';
        bgLight.setAttribute('width', 1.17);
        bgLight.setAttribute('height', 1.93);
        bgLight.setAttribute('depth', 0.002);
        bgLight.setAttribute('radius', 0.05);
        bgLight.setAttribute('color', '#FFFFFF');
        bgLight.setAttribute('position', '0 0 0');
        bgLight.setAttribute('opacity', 0.7);
        bgLight.setAttribute('material', { shader: 'flat', opacity: 0.7, color: '#FFFFFF' });
        bgLight.setAttribute('visible', false);
        parentEl.appendChild(bgLight);

        const anchor = document.createElement('a-entity');
        anchor.id = 'search-panel-ui-anchor';
        anchor.setAttribute('scale', `${1 / 1.2} ${1 / 0.75} 1`);
        parentEl.appendChild(anchor);
        const moveHandle = document.createElement('a-rounded-box');
        moveHandle.id = 'move-search-panel-area';
        moveHandle.setAttribute('width', '1.0');
        moveHandle.setAttribute('height', '0.15');
        moveHandle.setAttribute('depth', '0.01');
        moveHandle.setAttribute('radius', '0.05');
        moveHandle.setAttribute('opacity', '0.5');
        moveHandle.setAttribute('color', '#7676E3');
        moveHandle.setAttribute('drag-move', 'target: #search-center-panel');
        moveHandle.setAttribute('position', '0 1.09 0.1');
        moveHandle.setAttribute('visible', 'false');
        moveHandle.removeAttribute('data-raycastable');
        moveHandle.classList.add('clickable');
        parentEl.appendChild(moveHandle);

        const avgVolume = document.createElement('a-entity');
        avgVolume.id = 'center-average-volume';
        avgVolume.setAttribute('position', '-0.57 -0.2 0.05');
        avgVolume.setAttribute('scale', '0.18 0.2 1');
        avgVolume.setAttribute('right-average-volume-chart', '');
        anchor.appendChild(avgVolume);

        const stockChart = document.createElement('a-entity');
        stockChart.id = 'center-stock-chart';
        stockChart.setAttribute('position', '0.14 0.1 0.01');
        stockChart.setAttribute('scale', '0.16 0.16 1');
        // stockChart.setAttribute('tradingview-universal-chart', 'dataInterval: 1d; width: 600; height: 450; position: -0.35 0 0'); 
        anchor.appendChild(stockChart);

        const intervals = ["1D", "5D", "1M", "6M", "YTD", "1Y", "5Y"];
        const intBtnWidth = 0.15;
        const intBtnHeight = intBtnWidth * 0.6;
        const intBtnSpacing = 0.02;
        const totalIntWidth = intervals.length * intBtnWidth + (intervals.length - 1) * intBtnSpacing;
        const intBtnStartX = -totalIntWidth / 2 + intBtnWidth / 2;
        const intBtnY = -0.45;

        intervals.forEach((interval, i) => {
            const btn = document.createElement('a-entity');

            btn.setAttribute('ui-button', {
                label: interval,
                type: 'rounded-box',
                width: intBtnWidth,
                height: intBtnHeight,
                depth: 0.02,
                radius: 0.015,
                preferredFontSize: 0.03,
                colorScheme: 'tetriary',
                autosize: false,
                isSelectable: true,
                selected: (i === 0)
            });
            btn.setAttribute('position', `${intBtnStartX + (i * (intBtnWidth + intBtnSpacing))} ${intBtnY} 0.05`);
            btn.setAttribute('data-label', interval);
            btn.setAttribute('data-raycastable', '');

            btn.addEventListener('click', () => {
                const allBtns = parentEl.querySelectorAll('[data-label]');
                allBtns.forEach(b => {
                    if (intervals.includes(b.getAttribute('data-label'))) {
                        b.setAttribute('ui-button', 'selected', false);
                        b.setAttribute('scale', '1 1 1');
                    }
                });

                btn.setAttribute('ui-button', 'selected', true);
                btn.setAttribute('scale', '1.05 1.05 1.05');

                const is1D = interval === '1D';

                const avgVolumeEl = anchor.querySelector('#center-average-volume');
                if (avgVolumeEl) {
                    avgVolumeEl.setAttribute('visible', is1D ? 'true' : 'false');
                }

                const chart = parentEl.querySelector('#center-stock-chart');
                if (chart) {
                    chart.setAttribute('tradingview-universal-chart', {
                        dataInterval: interval.toLowerCase(),
                //         width: is1D ? 600 : 700,
                //         position: is1D ? '-0.35 0 0' : '-0.9 0 0'
                    });
                }
            });
            anchor.appendChild(btn);
        });

        const actionBtnY = -0.61;
        const actionBtnZ = 0.05;

        const btnWatchlist = document.createElement('a-entity');
        btnWatchlist.classList.add('search-action-btn');
        btnWatchlist.setAttribute('ui-button', {
            label: 'Add to watchlist',
            type: 'rounded-box',
            width: 0.33,
            height: 0.1,
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.035,
            autosize: false,
            colorScheme: 'primary'
        });
        btnWatchlist.setAttribute('position', `-0.22 ${actionBtnY} ${actionBtnZ}`);
        btnWatchlist.setAttribute('data-raycastable', '');
        btnWatchlist.addEventListener('click', () => {
            const manager = window.WatchlistApp && window.WatchlistApp.Manager;
            if (manager && manager.checkAuthorization) {
                manager.checkAuthorization().then(result => {
                    if (!result.authorized) {
                        if (window.AuthUI && window.AuthUI.showMessage) {
                            window.AuthUI.showMessage(result.message);
                        } else {
                            console.warn('AuthUI not available:', result.message);
                        }
                        return;
                    }
                    this._proceedAddToWatchlist();
                });
            }
        });
        anchor.appendChild(btnWatchlist);

        const btnCompare = document.createElement('a-entity');
        btnCompare.classList.add('search-action-btn');
        btnCompare.setAttribute('ui-button', {
            label: 'Compare',
            type: 'rounded-box',
            width: 0.33,
            height: 0.1,
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.035,
            autosize: false,
            colorScheme: 'primary'
        });
        btnCompare.setAttribute('position', `0.22 ${actionBtnY} ${actionBtnZ}`);
        btnCompare.setAttribute('data-raycastable', '');
        anchor.appendChild(btnCompare);

        const settingsBtn = document.createElement('a-entity');
        settingsBtn.setAttribute('ui-button', {
            label: '',
            image: '/vr-assets/right-container-buttons/configure.png',
            width: 0.07,
            height: 0.07,
            depth: 0.02,
            type: 'rounded-box',
            colorScheme: 'primary',
            radius: 0.015,
        });
        settingsBtn.setAttribute('position', `0.52 ${actionBtnY} ${actionBtnZ}`);
        settingsBtn.setAttribute('data-raycastable', '');
        settingsBtn.addEventListener('click', () => {
            const rightContainer = document.querySelector('#right-container');
            if (rightContainer && rightContainer.components['right-container-control']) {
                const comp = rightContainer.components['right-container-control'];
                if (comp._toggleRightConfigurePopup) comp._toggleRightConfigurePopup();
                else if (comp.toggleRightConfigurePopup) comp.toggleRightConfigurePopup();
            }
        });
        anchor.appendChild(settingsBtn);

        const closeText = document.createElement('a-troika-text');
        closeText.id = 'search-panel-close-text';
        closeText.setAttribute('value', '×');
        closeText.setAttribute('font-size', 0.08);
        closeText.setAttribute('anchor', 'center');
        closeText.setAttribute('align', 'center');
        closeText.setAttribute('baseline', 'middle');
        closeText.setAttribute('color', '#FFFFFF');
        closeText.setAttribute('position', '0.6 0.62 0.05');
        anchor.appendChild(closeText);
        const closeHitbox = document.createElement('a-plane');
        closeHitbox.setAttribute('width', 0.15);
        closeHitbox.setAttribute('height', 0.15);
        closeHitbox.setAttribute('opacity', 0);
        closeHitbox.setAttribute('position', '0.6 0.62 0.05');
        closeHitbox.setAttribute('data-raycastable', '');
        closeHitbox.addEventListener('click', () => {
            if (this.exitSearchMode) {
                this.exitSearchMode();
            } else {
                const searchComp = document.querySelector('[search-mode]').components['search-mode'];
                if (searchComp) searchComp.exitSearchMode();
            }
        });
        anchor.appendChild(closeHitbox);

        const noDataText = document.createElement('a-troika-text');
        noDataText.id = 'no-data-available-message-search';
        noDataText.setAttribute('visible', false);
        noDataText.setAttribute('position', '0.08 0.11 0.06');
        noDataText.setAttribute('font-size', '0.04');
        noDataText.setAttribute('color', this.themeMode === 'Light' ? '#1A1A1A' : '#FFFFFF');
        noDataText.setAttribute('align', 'center');
        noDataText.setAttribute('font-weight', 'bold');
        anchor.appendChild(noDataText);

        this.noDataMessageEl = noDataText;
        this.noDataTextEl = noDataText;
    },

    updateDataElements: function (anchor) {
        const stock = this.currentStock || {};

        const rvpPct = Number(stock.daypart_relative_volume_percentage);
        const volPayload = Number.isFinite(rvpPct) ? { rvp: rvpPct / 100, daypart_relative_volume_percentage: rvpPct } : { rvp: 0 };
        const volGauge = anchor.querySelector('#center-average-volume');
        if (volGauge) {
            volGauge.setAttribute('right-average-volume-chart', 'stockData', JSON.stringify(volPayload));
        }

        const chart = anchor.querySelector('#center-stock-chart');
        if (chart) {
            let type = 'mountain';
            try {
                if (typeof getCacheItem === 'function') {
                    const pType = getCacheItem('chart-type');
                    if (pType) type = pType.toLowerCase();
                }
            } catch (e) { }

            const chartData = {
                stockData: JSON.stringify(stock),
                type: type,
                width: 600, 
                height: 450,
                isSearchMode: true,
                
            };

            chart.setAttribute('tradingview-universal-chart', chartData);
        } else {
            console.error('[search-mode] Chart element #center-stock-chart NOT found in anchor!');
        }
    },

    updateBackgrounds: function () {
        const parentEl = document.querySelector('#search-center-panel');
        if (!parentEl) return;

        const isLight = this.themeMode === 'Light';
        const bgDark = parentEl.querySelector('#center-panel-bg-dark');
        const bgLight = parentEl.querySelector('#center-panel-bg-light');

        if (bgDark) bgDark.setAttribute('visible', !isLight);
        if (bgLight) bgLight.setAttribute('visible', isLight);

        const closeText = parentEl.querySelector('#search-panel-close-text');
        if (closeText) {
            closeText.setAttribute('color', isLight ? '#14141C' : '#FFFFFF');
        }

        if (this.noDataTextEl) {
            this.noDataTextEl.setAttribute('color', isLight ? '#1A1A1A' : '#FFFFFF');
        }
    },

    setupDataListeners: function () {
        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (!scene) return;

        scene.addEventListener('chart-data-fetch-complete', (evt) => {
            const { pointCount } = evt.detail;
            this.handleDataAvailability(pointCount > 0);
        });

        scene.addEventListener('chart-data-fetch-error', () => {
            this.handleDataAvailability(false);
        });

        scene.addEventListener('enter-search-mode', () => {
            this.handleDataAvailability(true);
        });

        scene.addEventListener('chart-data-fetch-started', () => {
            this.handleDataAvailability(true);
        });
    },

    handleDataAvailability: function (hasData) {
        if (!this.noDataMessageEl) return;

        if (hasData) {
            this.noDataMessageEl.setAttribute('visible', false);
        } else {
            const dateStr = new Intl.DateTimeFormat('en-US', {
                timeZone: 'America/New_York',
                month: '2-digit',
                day: '2-digit'
            }).format(new Date());
            const msg = `${dateStr} data not available yet`;

            if (this.noDataTextEl) {
                this.noDataTextEl.setAttribute('value', msg);
            }
            this.noDataMessageEl.setAttribute('visible', true);
        }
    }
});
